import getInitialState from './initialState';

export default {
  setStudent: (state, student) => Object.assign(state, { ...student }),

  setGrade: (state, grade) => Object.assign(state, { grade }),

  setClassroomId: (state, classroomId) => Object.assign(state, { classroomId }),

  setCurriculum: (state, curriculum) => Object.assign(state, { curriculum }),

  setCurriculumPosition: (state, position) => Object.assign(state, { position }),

  setNewBestResults: (state, bestResults) => Object.assign(state, { bestResults }),

  resetStudent: state => Object.assign(state, { ...getInitialState() }),

  setAccessibilitySettings: (state, accessibilitySettings) =>
    Object.assign(state, {
      accessibilitySettings
    }),

  setOneHandedTypingHand: (state, oneHandedTypingHand) =>
    Object.assign(state, { oneHandedTypingHand })
};
